// extracted by mini-css-extract-plugin
var _1 = "EmbedFooter-module__action--UJjbF";
var _2 = "EmbedFooter-module__animateUploadProgressBarWidth--uPBVd";
var _3 = "EmbedFooter-module__animatedBackground--g0L4i";
var _4 = "EmbedFooter-module__container--GTskR";
var _5 = "EmbedFooter-module__hasNativeFooter--XSue4";
var _6 = "EmbedFooter-module__icon--tZIgq";
var _7 = "EmbedFooter-module__link--RknyI";
var _8 = "EmbedFooter-module__linkContent--sMXns";
var _9 = "EmbedFooter-module__title--g9pSM";
export { _1 as "action", _2 as "animateUploadProgressBarWidth", _3 as "animatedBackground", _4 as "container", _5 as "hasNativeFooter", _6 as "icon", _7 as "link", _8 as "linkContent", _9 as "title" }
